import React from "react";
import {
  Checkbox,
  FormControl,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
} from "@mui/material";

interface Columns {
  text: string;
  name: string;
}

interface IProps {
  handleShowExternalColumns: (a: string[]) => void;
  relatedTables: string[];
  columns: Columns[];
}

const StyledFormControl = styled(FormControl)({
  width: "fit-content",
  minWidth: 200,
  maxWidth: 250,
});

const TableColumnsView: React.FC<IProps> = ({
  handleShowExternalColumns,
  relatedTables,
  columns,
}) => {
  const handleChange = (event: SelectChangeEvent<string[]>) =>
    handleShowExternalColumns(event.target.value as string[]);

  return (
    <StyledFormControl>
      <InputLabel id="column-multiple-checkbox-label">Column</InputLabel>
      <Select
        labelId="column-multiple-checkbox-label"
        id="column-multiple-checkbox"
        multiple
        input={<Input />}
        renderValue={(selected) => {
          const values = columns.filter(({ name }) => (selected as string[]).includes(name));
          return values.map(({ text }) => text).join(", ");
        }}
        value={relatedTables}
        onChange={handleChange}
        autoWidth
      >
        {columns.map(({ name, text }) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={relatedTables.indexOf(name) > -1} />
            <ListItemText primary={text} />
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
};

export default TableColumnsView;
